import React from "react";
import Home from "../pages/Home";
import Setup from "../pages/Setup";
import { CloudPremisePluginRoute } from "@cloudpremise/portal_core";

const routes = ({history, page, basename}): CloudPremisePluginRoute[] => {
    return [
        {
            route: "/servicedesk/cases",
            component: (
                <Home history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/servicedesk/setup",
            component: (
                <Setup history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
    ]
};

export default routes;